<script setup>
import { ref } from "vue";
import { useAuthStore } from "@/stores/auth"; // Importa tu store de autenticación
import Toast from "primevue/toast";

const email = ref("");
const password = ref("");
const isLoading = ref(false); // Estado para mostrar el spinner
const errors = ref({});
const authStore = useAuthStore(); // Accede al store de Pinia
import { useToast } from "primevue/usetoast";
import ModalEmail from "@/components/auth/modalEmail.vue";
const toast = useToast();

const login = async () => {
  isLoading.value = true; // Activar el spinner
  errors.value = {}; // Limpiar errores anteriores
  try {
    if (!email.value) {
      errors.value.email = "El correo electrónico es obligatorio.";
      throw new Error("Validación fallida.");
    }
    if (!password.value) {
      errors.value.password = "Se necesita una contraseña.";
      throw new Error("Validación fallida.");
    }

    await authStore.login({ email: email.value, password: password.value });
    console.log("Usuario autenticado");
    // Redirigir al usuario después de iniciar sesión (ajusta la ruta según tu aplicación)
    window.location.href = "/dashboard";
  } catch (error) {
    toast.add({
      severity: "error",
      summary: "Error",
      detail: "Los datos ingresados no coinciden con nuestros registros",
      life: 3000,
    });
    // errors.value.general = "Credenciales incorrectas. Inténtalo de nuevo.";
  } finally {
    isLoading.value = false; // Desactivar el spinner
  }
};

const isDialogVisible = ref(false); // Estado del modal

const openModal = () => {
  // Abre el modal de registro
  isDialogVisible.value = true;
}

</script>

<template>
  <div class="login-page">
    <Toast />

    <!-- Logo -->
    <div
      class="box-logo"
      style="position: absolute; z-index: 2; top: 0; left: 0"
    >
      <img
        src="../../assets/logounocomaseiscontacts.png"
        alt="Logo"
        class="img-fluid"
        style="width: 191px; margin-top: 26px; margin-left: 50px"
      />
    </div>

    <!-- Fondo de la página -->
    <div class="login-page-bg"></div>

    <!-- Contenedor del formulario -->
    <div class="login-container">
      <div class="login-header">
        <h1>¡Te damos la bienvenida de nuevo!</h1>
      </div>
      <form
        class="login-form"
        @submit.prevent="login"
      >
        <div class="form-group">
          <label for="email">Correo electrónico</label>
          <input
            id="email-login"
            type="email"
            placeholder="Ingresa tu correo electrónico"
            v-model="email"
            required
          />
          <p
            v-if="errors.email"
            class="error"
          >
            {{ errors.email }}
          </p>
        </div>
        <div class="form-group">
          <label for="password">Contraseña</label>
          <input
            id="password-login"
            type="password"
            placeholder="Escribe la contraseña"
            v-model="password"
            required
          />
          <p
            v-if="errors.password"
            class="error"
          >
            {{ errors.password }}
          </p>
        </div>

        <!-- Botón con spinner -->
        <button
          type="submit"
          class="login-button"
          :disabled="isLoading"
        >
          <span v-if="!isLoading">Iniciar sesión</span>
          <span v-else> <i class="spinner"></i> Cargando... </span>
        </button>
      </form>
    </div>

    <strong
      class="title-footer"
      style="
        position: absolute;
        z-index: 2;
        font-weight: 500;
        color: white;
        bottom: 130px;
      "
    >
      No tienes cuenta?
      <strong @click="openModal" style="text-decoration: underline; cursor: pointer;"
        >Pídela al admin del sitio</strong
      >
    </strong>

    <small
      class="subtitle-footer"
      style="
        position: absolute;
        z-index: 2;
        bottom: 30px;
        /* font-weight: 700; */
        color: white;
      "
      >Este sitio está protegido por reCAPTCHA, y se aplican la
      <a
        href="#"
        style="font-weight: 700; color: white"
        >política de privacidad</a
      >
      y las
      <a
        href="#"
        style="font-weight: 700; color: white"
        >condiciones de servicio de Google.</a
      ></small
    >
    <ModalEmail  
      :visible="isDialogVisible"
      @update:visible="isDialogVisible = $event" />

  </div>
</template>

<style scoped>
@media(min-width: 768px){
  
}
@media(max-width: 768px){
  .title-footer {
    bottom: 210px !important;
   }

   .subtitle-footer {
    bottom: 90px !important;
   }

  /* Estructura para móviles */
 .login-container {
  margin-top: -152px !important;
  background: #fafbfc !important;
  box-shadow: none !important;
  padding: 1rem !important;
 }
}
/* Estructura general */
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #fafbfc;
}

/* Fondo múltiple */
.login-page-bg {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/login__bg-top.svg") center top no-repeat,
    url("../../assets/login__bg-dots.svg") center top repeat,
    url("../../assets/login__bg2.svg") center no-repeat;
  z-index: 1;
  background-size: 100%, auto, cover;
  top: 253px;
}

/* Contenedor del formulario */
.login-container {
  position: relative;
  z-index: 2;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 445px;
  width: 100%;
}

.login-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.login-header h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
}

/* Estilo del formulario */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group {
  text-align: left;
  display: flex;
  flex-direction: column;
}

label {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #333;
}

input {
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
}

input:focus {
  border-color: #6c63ff;
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 99, 255, 0.1);
}

.error {
  color: #ff4d4f;
  font-size: 0.8rem;
  margin-top: 0.3rem;
}

.login-button {
  padding: 0.8rem;
  background: #6c63ff;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-button:hover {
  background: #5753d8;
}

.login-button:disabled {
  background: #ddd;
  cursor: not-allowed;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
